import { IActionConfigSet } from '../actions/config'
import { CONFIG_SET } from '../constants/ActionTypes'
import { ConfigStore } from '../model/Store/ConfigStore'

type ConfigActions = IActionConfigSet

const config = (state: ConfigStore = new ConfigStore(), action: ConfigActions) => {
  switch (action.type) {
    case CONFIG_SET:
      return {
        ...state,
        ...action.settings,
        initialized: true,
      }
    default:
      return state
  }
}

export default config
